import React, { useState } from 'react';
import { Select } from 'tea-component';

export default function Choose(props: {
  selects: {
    value: string;
    text: string;
  }[];

  prefix?: string;
  defaultValue?: string;
  onChange?: (type: string) => void;
  footer?: any;
}) {
  const { selects = [], onChange, defaultValue, prefix, footer } = props;
  const [choose, setChoose] = useState(
    defaultValue ?? (selects[0]?.value || ''),
  );

  const renderText = () => {
    return selects.find((item) => item.value === choose)?.text || 'None';
  };

  return (
    <Select
      appearance="button"
      className="select-topposts"
      options={selects}
      matchButtonWidth
      value={choose}
      button={
        <div className="select-button">
          <div className="select-button-text">{prefix}</div>
          <div className="dbo-select-value">
            <span>{renderText()}</span>
          </div>
        </div>
      }
      footer={footer}
      onChange={(value, context) => {
        context.event.stopPropagation();
        setChoose(value);
        onChange?.(value);
      }}
    />
  );
}
